import { Button, Modal, Form, Input, Select } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { IPenaltyBeforeUpload } from "../../services/penalty";
import { useEffect, useState } from "react";
import {
  PenaltyCategory,
  PenaltyJustificationCategory,
} from "../../services/penalty";

const { TextArea } = Input;
const { Option } = Select;

const SubmittedJustificationModal = (props: {
  onOk: (updatedJustification: {
    body: string;
    category: PenaltyCategory;
  }) => void;
  onClose: () => void;
  open: boolean;
  data: IPenaltyBeforeUpload | null;
}) => {
  const [form] = Form.useForm();
  const [isEditable, setIsEditable] = useState(false);

  useEffect(() => {
    if (props.data) {
      setIsEditable(props.data.status === "TO_REVIEW");
      form.setFieldsValue({
        body: props.data.justification?.body || "",
        category: props.data.justification?.category || undefined,
      });
    }
  }, [props.data, form]);

  const handleSave = () => {
    form.validateFields().then((values) => {
      props.onOk({
        body: values.body,
        category: values.category,
      });
    });
  };

  const ModalTitle = (
    <>
      <EditOutlined style={{ marginRight: "8px", color: "blue" }} />
      Modifica Giustificazione - {props?.data?.sennder_reference} (
      {props?.data?.tour_composition})
    </>
  );

  return (
    <Modal
      width={700}
      title={ModalTitle}
      open={props.open}
      closable={true}
      onCancel={props.onClose}
      footer={[
        <Button key="cancel" onClick={props.onClose}>
          Annulla
        </Button>,
        <Button
          key="save"
          type="primary"
          onClick={handleSave}
          disabled={!isEditable}
        >
          Salva
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        {props?.data?.delay_type !== "Positioning" && (
          <Form.Item
            name="category"
            label="Categoria"
            rules={[{ required: true, message: "Seleziona una categoria" }]}
          >
            <Select placeholder="Seleziona categoria" disabled={!isEditable}>
              {Object.entries(PenaltyJustificationCategory).map(
                ([key, value], i) => (
                  <Option key={key + i} value={key}>
                    {value}
                  </Option>
                ),
              )}
            </Select>
          </Form.Item>
        )}

        <Form.Item
          name="body"
          label="Giustificazione"
          rules={[{ required: true, message: "Inserisci una giustificazione" }]}
        >
          <TextArea
            rows={6}
            placeholder="Inserisci giustificazione"
            disabled={!isEditable}
            maxLength={200}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SubmittedJustificationModal;
